import React,{forwardRef, useState, useEffect} from 'react'
import AttributeForm from './AttributeForm'
import UpdateDrawerInfo from '../../../../../../../../../component/common/UpdateDrawerInfo';
const AttributeUpdateDrawer = forwardRef((props, ref) => {
    const {
        formValidateError,
        attributeFormSave,
        updateAttributeState,
        isButtonLoader,
        drawerIsOpen
    } = props;

    const [updateInfo, setUpdateInfo] = useState({
        isOpen: '',
        title: '',
        information: ''
    });

    const colmd = updateInfo.isOpen === 'open' ? 'col-md-7' : 'col-md-12'

    useEffect(() => {
        props.isUpdateInfo(updateInfo)
    }, [updateInfo]);

     useEffect(() => {
        if(!drawerIsOpen){
            setUpdateInfo({
                isOpen: 'close',
                title: '',
                information: '',
            })
        }
    },[drawerIsOpen])


    return (
        <>
            <div className='row p-5'>
                <div className={`${colmd}`}>
                    <AttributeForm
                        formValidateError={formValidateError}
                        attributeFormSave={attributeFormSave}
                        updateAttributeState={updateAttributeState}
                        formActionType={'update'}
                        ref={ref}
                        isButtonLoader={isButtonLoader}
                        isInfoOpenHandler={(data) => 
                            setUpdateInfo({
                                isOpen: data.type,
                                title: data.data.title,
                                information: data.data.info,
                            })
                        }
                    />
                </div>
                {
                    updateInfo.isOpen === 'open' &&
                    <div className={`col-md-5`}>
                        <UpdateDrawerInfo
                            title={updateInfo.title}
                            information={updateInfo.information}
                            infoCloseOnClick={() => 
                                setUpdateInfo({
                                    isOpen: '',
                                    title: '',
                                    information: '',
                                })
                            }
                        />
                    </div>
                }
            </div>
        </>
    )
})

export default AttributeUpdateDrawer